import { SERVICES } from "../data/siteData";
import { Link } from "react-router-dom";
const actionButtons = [
  {
    text: "Contact Us Today",
    link: "/contact",
    className: "btn btn-dark btn-lg px-4",
  },
];

export function Services() {
  return (
    <div className="page-bg services-bg">
      <div className="page-overlay">
        {/* Hero Section */}
        <div className="services-hero bg-dark text-white py-5">
          <div className="container py-4">
            <div className="row justify-content-center">
              <div className="col-lg-8 text-center">
                <i
                  className="bi bi-briefcase-fill text-warning"
                  style={{ fontSize: "3rem" }}
                ></i>

                <h1 className="display-4 fw-bold mb-3">Our Services</h1>
                <p className="lead mb-0">
                  Comprehensive AI software development and integration
                  solutions tailored to your security and monitoring needs
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Services Grid */}
        <div className="container py-5">
          <div className="row g-4 mt-2">
            {SERVICES.map((service, idx) => (
              <div className="col-lg-6" key={idx}>
                <div className="service-detail-card card h-100 border-0 shadow-sm">
                  <div className="card-body p-4 p-lg-5">
                    <div className="d-flex align-items-start mb-3">
                      <div className="service-number me-3">
                        <span className="badge bg-warning text-dark fs-5 px-3 py-2 rounded-3">
                          {String(idx + 1).padStart(2, "0")}
                        </span>
                      </div>
                      <div className="flex-grow-1">
                        <h4 className="fw-bold mb-3">{service.title}</h4>
                        <p className="text-muted mb-4">{service.desc}</p>

                        {/* Add specific deliverables for each service */}
                        <div className="service-highlights">
                          <h6 className="fw-semibold mb-3 text-uppercase small">
                            Key Deliverables:
                          </h6>
                          <ul className="list-unstyled small">
                            {idx === 0 && (
                              <>
                                <li className="mb-2">
                                  <i className="bi bi-check2 text-warning me-2"></i>
                                  Custom AI detection algorithms
                                </li>
                                <li className="mb-2">
                                  <i className="bi bi-check2 text-warning me-2"></i>
                                  Real-time processing pipelines
                                </li>
                                <li className="mb-2">
                                  <i className="bi bi-check2 text-warning me-2"></i>
                                  Dashboard and analytics platforms
                                </li>
                              </>
                            )}
                            {idx === 1 && (
                              <>
                                <li className="mb-2">
                                  <i className="bi bi-check2 text-warning me-2"></i>
                                  Optimized neural networks
                                </li>
                                <li className="mb-2">
                                  <i className="bi bi-check2 text-warning me-2"></i>
                                  Object detection & classification models
                                </li>
                                <li className="mb-2">
                                  <i className="bi bi-check2 text-warning me-2"></i>
                                  Behavioral analysis algorithms
                                </li>
                              </>
                            )}
                            {idx === 2 && (
                              <>
                                <li className="mb-2">
                                  <i className="bi bi-check2 text-warning me-2"></i>
                                  Dataset collection & annotation
                                </li>
                                <li className="mb-2">
                                  <i className="bi bi-check2 text-warning me-2"></i>
                                  Model training & validation
                                </li>
                                <li className="mb-2">
                                  <i className="bi bi-check2 text-warning me-2"></i>
                                  Performance benchmarking
                                </li>
                              </>
                            )}
                            {idx === 3 && (
                              <>
                                <li className="mb-2">
                                  <i className="bi bi-check2 text-warning me-2"></i>
                                  Hardware-software integration
                                </li>
                                <li className="mb-2">
                                  <i className="bi bi-check2 text-warning me-2"></i>
                                  RESTful API development
                                </li>
                                <li className="mb-2">
                                  <i className="bi bi-check2 text-warning me-2"></i>
                                  VMS platform connectors
                                </li>
                              </>
                            )}
                            {idx === 4 && (
                              <>
                                <li className="mb-2">
                                  <i className="bi bi-check2 text-warning me-2"></i>
                                  Edge Sofware deployment optimization
                                </li>
                                <li className="mb-2">
                                  <i className="bi bi-check2 text-warning me-2"></i>
                                  High-Performance, Scalable Software Solutions
                                </li>
                                <li className="mb-2">
                                  <i className="bi bi-check2 text-warning me-2"></i>
                                  Performance monitoring tools
                                </li>
                              </>
                            )}
                            {idx === 5 && (
                              <>
                                <li className="mb-2">
                                  <i className="bi bi-check2 text-warning me-2"></i>
                                  System architecture design
                                </li>
                                <li className="mb-2">
                                  <i className="bi bi-check2 text-warning me-2"></i>
                                  Technical documentation
                                </li>
                                <li className="mb-2">
                                  <i className="bi bi-check2 text-warning me-2"></i>
                                  Ongoing maintenance & support
                                </li>
                              </>
                            )}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Process Section */}
        <div className="process-section bg-light py-5 mt-5">
          <div className="container py-4">
            <div className="text-center mb-5">
              <h2 className="fw-bold display-6 mb-3">
                Our Development Process
              </h2>
              <p className="text-muted lead">
                A proven methodology for delivering high-performance thermal AI
                solutions
              </p>
            </div>
            <div className="row g-4">
              <div className="col-md-6 col-lg-3">
                <div className="process-step text-center">
                  <div className="process-icon mb-3">
                    <div
                      className="rounded-circle bg-warning d-inline-flex align-items-center justify-content-center"
                      style={{ width: "80px", height: "80px" }}
                    >
                      <span className="fw-bold fs-3">1</span>
                    </div>
                  </div>
                  <h5 className="fw-bold mb-2">Discovery</h5>
                  <p className="text-muted small">
                    Requirements analysis and feasibility study
                  </p>
                </div>
              </div>
              <div className="col-md-6 col-lg-3">
                <div className="process-step text-center">
                  <div className="process-icon mb-3">
                    <div
                      className="rounded-circle bg-warning d-inline-flex align-items-center justify-content-center"
                      style={{ width: "80px", height: "80px" }}
                    >
                      <span className="fw-bold fs-3">2</span>
                    </div>
                  </div>
                  <h5 className="fw-bold mb-2">Design</h5>
                  <p className="text-muted small">
                    Architecture design and model selection
                  </p>
                </div>
              </div>
              <div className="col-md-6 col-lg-3">
                <div className="process-step text-center">
                  <div className="process-icon mb-3">
                    <div
                      className="rounded-circle bg-warning d-inline-flex align-items-center justify-content-center"
                      style={{ width: "80px", height: "80px" }}
                    >
                      <span className="fw-bold fs-3">3</span>
                    </div>
                  </div>
                  <h5 className="fw-bold mb-2">Development</h5>
                  <p className="text-muted small">
                    AI training, software development, and testing
                  </p>
                </div>
              </div>
              <div className="col-md-6 col-lg-3">
                <div className="process-step text-center">
                  <div className="process-icon mb-3">
                    <div
                      className="rounded-circle bg-warning d-inline-flex align-items-center justify-content-center"
                      style={{ width: "80px", height: "80px" }}
                    >
                      <span className="fw-bold fs-3">4</span>
                    </div>
                  </div>
                  <h5 className="fw-bold mb-2">Deployment</h5>
                  <p className="text-muted small">
                    Integration, deployment, and ongoing support
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Industries Section */}
        {/* <div className="industries-section py-5">
          <div className="container py-4">
            <div className="text-center mb-5">
              <h2 className="fw-bold display-6 mb-3">Industries We Serve</h2>
              <p className="text-muted lead">
                Thermal AI detection solutions across multiple sectors
              </p>
            </div>
            <div className="row g-4">
              <div className="col-md-4">
                <div className="industry-card card border-0 shadow-sm h-100">
                  <div className="card-body p-4 text-center">
                    <i className="bi bi-shield-check fs-1 text-warning mb-3"></i>
                    <h5 className="fw-bold mb-2">Security & Surveillance</h5>
                    <p className="text-muted small mb-0">
                      Perimeter protection, intrusion detection, and threat
                      assessment
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="industry-card card border-0 shadow-sm h-100">
                  <div className="card-body p-4 text-center">
                    <i className="bi bi-building fs-1 text-warning mb-3"></i>
                    <h5 className="fw-bold mb-2">Critical Infrastructure</h5>
                    <p className="text-muted small mb-0">
                      Power plants, airports, and government facilities
                      monitoring
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="industry-card card border-0 shadow-sm h-100">
                  <div className="card-body p-4 text-center">
                    <i className="bi bi-gear-fill fs-1 text-warning mb-3"></i>
                    <h5 className="fw-bold mb-2">Industrial & Manufacturing</h5>
                    <p className="text-muted small mb-0">
                      Equipment monitoring, safety compliance, and process
                      optimization
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}

        {/* CTA Section */}
        <div className="cta-section bg-warning py-5">
          <div className="container py-4">
            <div className="row align-items-center">
              <div className="col-lg-8 mb-3 mb-lg-0 text-center text-lg-start">
                <h3 className="fw-bold mb-2">
                  Let’s Turn Your Software Vision Into Reality.
                </h3>
                <p className="mb-0 opacity-75">
                  Discuss your project requirements with our experts
                </p>
              </div>
              <div className="col-lg-4 text-center text-lg-end">
                {actionButtons.map((btn, index) => (
                  <Link
                    key={index}
                    to={btn.link}
                    className={btn.className}
                    onClick={() =>
                      window.scrollTo({
                        top: 0,
                        left: 0,
                        behavior: "smooth",
                      })
                    }
                  >
                    {btn.text}
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
